
import { checkIdType } from "@/assets/utils/network";
var myMixin = {
  data() {
    return {
      noPermission: [],
    };
  },
  mounted() {
    //需要删除的项
    let targetActives = [];
    //加盟商管理员权限
    if (checkIdType("dealerLevel2")) {
      targetActives.push('2-4','8-1-5','8-2-4','8-3-4','8-4-5','3-1','9','6-1','6-2-1','6-2-0','6-6');
      // 9、6-1 被拆分
      targetActives.push('9-3','9-6-1','9-1','9-2','9-0','9-4-0','9-4-1','9-4-2','6-1-0','6-1-2',);
      // 营销中心
      targetActives.push('7-1-2','7-1-3','7-2-1','7-2-4','7-2-3','7-2-5','7-6','7-3','7-4-0','7-4-1','7-5-0','7-5-1','7-5-2',);
    }
    // 站点管理员权限
    if(checkIdType("site")){
      targetActives.push('1','2-1-0','6');
      // 6 被拆分
      targetActives.push('6-1-0','6-1-2','6-2-0','6-2-1','6-3','6-4-0','6-4-1','6-6',)
      // 营销中心
      targetActives.push('7-1-2','7-1-3','7-2-1','7-6','7-3','7-4-0','7-4-1','7-5-0','7-5-1','7-5-2');
    }
    this.noPermission = targetActives;
  },
};

export default myMixin;
